import { Component, Input, Output, EventEmitter, forwardRef, HostListener, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface DropdownOption {
  value: string | number | boolean;
  label: string;
}

@Component({
  selector: 'app-custom-dropdown',
  templateUrl: './custom-dropdown.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomDropdownComponent),
      multi: true
    }
  ]
})
export class CustomDropdownComponent implements ControlValueAccessor {
  @Input() options: DropdownOption[] = [];
  @Input() placeholder = 'Selecione uma opção';
  @Input() disabled = false;
  @Input() label = '';
  @Input() id = '';
  
  @Output() selectionChange = new EventEmitter<string | number | boolean>();

  isOpen = false;
  selectedValue: string | number | boolean | null = null;
  
  private onChange: (value: string | number | boolean) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  get displayLabel(): string {
    if (this.selectedValue === null || this.selectedValue === undefined) return this.placeholder;
    const option = this.options.find(o => o.value === this.selectedValue);
    return option ? option.label : this.placeholder;
  }

  toggle(): void {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectOption(option: DropdownOption): void {
    this.selectedValue = option.value;
    this.isOpen = false;
    this.onChange(option.value);
    this.onTouched();
    this.selectionChange.emit(option.value);
  }

  // ControlValueAccessor implementation
  writeValue(value: string | number | boolean): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: (value: string | number | boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
